import { InventoryTypePlaceholderPage } from "../inventory-placeholder";

export const ClinicalUrinePage = () => {
  return <InventoryTypePlaceholderPage title="Clinical Urine" />;
};
